// @core/api/endpoints/authn/disable_two_factor_auth.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DisableTwoFactorAuthRequest,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Disable two-factor authentication
 * Disables two-factor authentication for the user's account. Requires password confirmation for security. This action invalidates all existing backup codes.
 */
export async function DisableTwoFactorAuth(
  data: DisableTwoFactorAuthRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/auth/2fa/disable`;
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
